import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-12% 0px -12% 0px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, stagger = 0.09 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span className="line-mask" key={i}>
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 1.05, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Rule = ({ className = "" }) => (
  <motion.div
    className={`h-px bg-white/10 origin-left ${className}`}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
  />
);

export const SectionLabel = ({ children, index }) => (
  <div className="flex items-baseline gap-4">
    {index ? <span className="label text-white/30">{index}</span> : null}
    <span className="label">{children}</span>
  </div>
);
